import { Typography } from '@mui/material';
import { visuallyHidden } from '@mui/utils';

interface PageTitleProps {
  text: string;
  screenreaderOnly?: boolean;
}

export default function PageTitle({
  text,
  screenreaderOnly = false,
}: Readonly<PageTitleProps>) {
  return (
    <Typography
      variant='h1'
      tabIndex={-1}
      sx={screenreaderOnly ? visuallyHidden : {}}
    >
      {text}
    </Typography>
  );
}
